import { call, put, takeLatest } from 'redux-saga/effects';
import { SeenAnAnnouncementTypes } from '../redux/SeenAnAnnouncementRedux';
import SeenAnAnnouncementActions from '../redux/SeenAnAnnouncementRedux';
import { api } from './api';

export function* seenAnAnnouncementRequest(action: any): Generator<any, void, any> {
  const { announcementId } = action;
  
  try {
    const response = yield call(api.seenAnAnnouncement, announcementId);
    
    if (response.ok) {
      yield put(SeenAnAnnouncementActions.seenAnAnnouncementSuccess(response.data));
    } else {
      yield put(SeenAnAnnouncementActions.seenAnAnnouncementFailure());
    }
  } catch (error) {
    yield put(SeenAnAnnouncementActions.seenAnAnnouncementFailure());
  }
}

export default function* seenAnAnnouncementSaga(): Generator<any, void, any> {
  yield takeLatest(SeenAnAnnouncementTypes.SEEN_AN_ANNOUNCEMENT_REQUEST, seenAnAnnouncementRequest);
}